/*@ngInject*/
const ChangeProductsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.changeProduct = function (submissionId, productShortNames) {
        var url = '/rest/Submission/' + submissionId + '/changeProduct?productShortNames=' + productShortNames;

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('changeProductsRepository', ChangeProductsRepository);
